import { getHttpStatus, isNetworkError } from "@/utils/httpErrors";

export type AmenityAccess = {
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canToggleStatus: boolean;
};

/** Front Desk with `read` on hotel settings sees the list and nothing else. */
export const getAmenityAccess = (canAdminister: boolean): AmenityAccess => ({
  canCreate: canAdminister,
  canEdit: canAdminister,
  canDelete: canAdminister,
  canToggleStatus: canAdminister,
});

export type AmenitySaveAction = "create" | "update";

export const AMENITY_SAVE_ERROR_KEYS = {
  forbidden: "amenities.errors.forbidden",
  network: "amenities.errors.network",
  create: "amenities.errors.createFailed",
  update: "amenities.errors.updateFailed",
} as const;

/** i18n key of the toast shown when saving the amenity form fails. */
export const getAmenitySaveErrorKey = (
  error: unknown,
  action: AmenitySaveAction,
): string => {
  if (isNetworkError(error)) return AMENITY_SAVE_ERROR_KEYS.network;
  if (getHttpStatus(error) === 403) return AMENITY_SAVE_ERROR_KEYS.forbidden;
  return AMENITY_SAVE_ERROR_KEYS[action];
};
